export const taskPublish = {
    method: 'post',
    url: '/admin/task/publish',
    config: {
        headers: { 'Content-Type': 'multipart/form-data' }
    }
}
export const taskNoJoinUser = {
    method: 'get',
    url: '/admin/task/getNoJoinUser'
}
export const taskList = {
    method: 'get',
    url: '/admin/task/list'
}
export const taskCancel = {
    method: 'post',
    url: '/admin/task/cancel'
}
export const taskDetail = {
    method: 'get',
    url: '/admin/task/detail'
}
export const taskUserRecord = {
    method: 'get',
    url: '/admin/task/userTaskRecord'
}
export const myProgresstList = {
    method: 'get',
    url: '/admin/science/getMyProgressList.json'
}
export const getSupplierTreeInfoByScienceId = {
    method: 'get',
    url: '/admin/supplierGroup/getStructureTreeInfo4ScienceId.json'
}
export const getGoalProdList = {
    method: 'get',
    url: '/admin/taskManager/target/selectProduct'
}
export const targetNoJoinUser = {
    method: 'get',
    url: '/admin/taskManager/target/getNoJoinUser'
}
export const targetPublish = {
    method: 'post',
    url: '/admin/taskManager/target/publish'
}
export const targetList = {
    method: 'get',
    url: '/admin/taskManager/target/list'
}
export const targetDetail = {
    method: 'get',
    url: '/admin/taskManager/target/detail'
}
export const validTargetImport = {
    method: 'post',
    url: '/admin/taskManager/target/import/check'
}